import {setOrFallbackValue} from './helper';
import SupplierStock from './supplier_stock';
export default class CartItemStock {
    constructor(props) {
        this.qty = setOrFallbackValue(props, 'qty', 0);
        this.supplierStock = ('' === setOrFallbackValue(props, 'supplierStock', '')) ?
            null : new SupplierStock(props.supplierStock);
    }
}

